export class Version
{
    hash: string;
}
